import React, { useState } from 'react';
import { View, Input, Text, Button, FormControl } from 'native-base';
import { FontAwesome } from '@expo/vector-icons';
import { TouchableOpacity } from 'react-native';
import { liveTTScoreboardButtonTextColor } from '../../../livettscoreboard.config';



export default function QRCodeButton({navigation, url, tableName}){



    return (
        
        <View padding={1}>
            <Button
            onPress={()=>{
                navigation.navigate("QRCodeScreen", {url:url, tableName:tableName})
            }}
            >
               
                    <FontAwesome name="qrcode" color={liveTTScoreboardButtonTextColor} size={24} />
                
                
            </Button>
        </View>
    )
}